export default "__VITE_ASSET__CDJ$98b2__"